// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"installCalculator_Wrapper__Hr3sf"};